/*
 * Copyright (c) 2016 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var _ = require('underscore');
var opPaymentAccount = require('op-payment-account');
var sendResponseMessage = require('./services/message.service');

/**
 * Constant used to make a short delay to replace instant validation
 * used on focus of input field or onchange of select box
 * value in ms
 */
var VALIDATIONSHORTDELAY = 100;

/**
 * Get Container To Validate, to make sure that validation doesn't run for any input field in the page
 * @param {object} rootScope
 * @param {boolean} isIframe validation required in iframe (selective native)
 *
 * @returns {jqueryObject}
 */
function getContainerToValidate(rootScope, isIframe) {
    // if it is called form iframe, there is no container, the web page of the iframe contain only the form
    // so use body
    if (isIframe) {
        return $('body');
    }
    // if it is possible to access listContainer element from rootScope, use it
    if (rootScope && rootScope.getListContainer && rootScope.getListContainer()) {
        return rootScope.getListContainer();
    }

    return $('body');
}

/**
 * add live validation to the current form specified in rootScope
 * @param {object} rootScope has getter and setter for window.glob variables (need to have: getValidationTimer,getSelectedNetworkCode,setValidationTimer,getValidationDelay,getSelectedNetwork and getTranslationObject)
 * @param {object} paymentApi has validateAccount() to call the api for validation
 * @param {function} handleServiceError to handle api error
 * @param {boolean} IsIframe if the form is in selected native iframe
 */
function addLiveValidation(rootScope, paymentApi, handleServiceError, isIframe) {
    var containerToValidate;
    function validate() {
        window.glob.validationShortTimer && window.glob.validationShortTimer.cancel && window.glob.validationShortTimer.cancel();
        window.glob.validationTimer && window.glob.validationTimer.cancel && window.glob.validationTimer.cancel();
        validateField(rootScope, $('#' + rootScope.getSelectedNetworkCode() + 'form'), paymentApi, handleServiceError, isIframe);
    }
    window.glob.validationShortTimer = _.debounce(validate, VALIDATIONSHORTDELAY);
    window.glob.validationTimer = _.debounce(validate, rootScope.getValidationDelay());

    //get the container to add listener of events to, to not be listening to any irrelevant changes in the page
    containerToValidate = getContainerToValidate(rootScope, isIframe);
    containerToValidate.on('keyup paste change', 'input[type="text"]', window.glob.validationTimer);
    containerToValidate.on('change', 'select', window.glob.validationShortTimer);
    containerToValidate.on('blur', 'input[type="text"],select', window.glob.validationShortTimer);
}

/**
 * Validates the provided field.
 * @param {object} rootScope
 * @param {jqueryObject} form
 * @param {object} paymentApi
 * @param {function} handleServiceError
 * @param {boolean} IsIframe if the form is in selected native iframe
 */
function validateField(rootScope, form, paymentApi, handleServiceError, isIframe) {
    var selectedNetwork = rootScope.getSelectedNetwork();
    //enable validation if there is a validation-link
    if (selectedNetwork && selectedNetwork.links && selectedNetwork.links.validation) {
        var formMap = form.find('input,select,textarea').serializeArray();
        var account = opPaymentAccount.fromForm(formMap);
        var validate = paymentApi.validateAccountByOrder || paymentApi.validateAccount;
        var bindingData = {
            rootScope: rootScope,
            paymentApi: paymentApi,
            handleServiceError: handleServiceError,
            isIframe: isIframe,
        };

        validate(selectedNetwork.links.validation, account, liveValidationCallback, bindingData);
    }
}
/**
 * Live validation callback.
 *
 * @param {object} err The api error
 * @param {object} data The response containing information which fields are valid or not
 * @param {object} bindingData data to be bind from main function to the callback
 */
function liveValidationCallback(err, data, bindingData) {
    //if there is an error in the response of liveValidation, just ignore
    if (err) {
        return err;
    }

    var name, message, inputFields, messageField, hasData, hasFocus, hasValidationOnSubmit;
    var elementIdPrefix = '#' + bindingData.rootScope.getSelectedNetworkCode() + 'form ';
    hasValidationOnSubmit = $(elementIdPrefix).hasClass('has-validation-on-submit');
    if (bindingData.isIframe) {
        sendResponseMessage(null, 'validation_response_event', data);
    }

    for (name in data.messages) {
        messageField = $(elementIdPrefix + '[id$=' + name + '-message]');
        // process only messages that are reflected on the form
        message = data.messages[name];

        if (!message || !messageField.length) {
            continue;
        }

        if (message.referredTo && message.referredTo.length) {
            // message for compound field
            inputFields = [];
            $.each(message.referredTo, function (index, refName) {
                inputFields.push($(elementIdPrefix + '[id$=' + refName + ']'));
            });
        } else {
            // direct message
            inputFields = [$(elementIdPrefix + '[id$=' + name + ']')];
        }

        // reset message field
        removeValidationCss(messageField);
        messageField.html('');

        hasData = false;
        hasFocus = false;
        // process input fields
        $.each(inputFields, function (index, inputField) {
            // remove CSS decoration from field
            removeValidationCss(inputField.parent());
            if (inputField.val() != '' && !inputField.is(':checkbox')) {
                // val() wont show actual value of checkBox field, simply disable live validation for checkBoxes
                hasData = true;
            }
            if (inputField.is(':focus')) {
                hasFocus = true;
            }
        });

        if ((hasData || hasValidationOnSubmit) && (message.type != 'ERROR' || !hasFocus)) {
            // don't show error messages while the user is typing, only successful messages
            messageField.addClass(message.type);
            var messageFieldContent = message.message;
            messageField.html(messageFieldContent);

            $.each(inputFields, function (index, inputField) {
                inputField.parent().addClass(message.type);
                inputField.parents('.row').addClass(message.type + '-ROW');
            });
        }
    }
}
/**
 * Cleanup set validation-CSS-classes in provided HTML-element
 * @param {jqueryObject} element HTML element to clean up.
 */
function removeValidationCss(element) {
    element.removeClass('ERROR INFO');
    element.parents('.row').removeClass('ERROR-ROW INFO-ROW');
}

module.exports = {
    addLiveValidation: addLiveValidation,
    removeValidationCss: removeValidationCss,
};
